// extracted by mini-css-extract-plugin
module.exports = {"newsCard":"style_newsCard__ba93U"};